module.exports = __webpack_public_path__ + "static/media/sa4.f546e402.jpg";